export default "__VITE_ASSET__BpJY3BB9__"